// extracted by mini-css-extract-plugin
export default {"price":"PriceBlock_price__sPziD","oldPrice":"PriceBlock_oldPrice__xZG67"};